export default __webpack_public_path__ + "images/UP.cc17248.png";